'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dData$002dForm from "./app.data.-App-Document-Data-Form.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_DocumentsCreatePage$$anon$4() {
}
export { $c_Lapp_pages_DocumentsCreatePage$$anon$4 as $c_Lapp_pages_DocumentsCreatePage$$anon$4 };
$p = $c_Lapp_pages_DocumentsCreatePage$$anon$4.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$p.constructor = $c_Lapp_pages_DocumentsCreatePage$$anon$4;
/** @constructor */
function $h_Lapp_pages_DocumentsCreatePage$$anon$4() {
}
export { $h_Lapp_pages_DocumentsCreatePage$$anon$4 as $h_Lapp_pages_DocumentsCreatePage$$anon$4 };
$h_Lapp_pages_DocumentsCreatePage$$anon$4.prototype = $p;
$p.Jz = (function(x) {
  return (x instanceof $j_app$002edata$002e$002dApp$002dDocument$002dData$002dForm.$c_Lapp_data_AppDocumentDataForm$CreditNote);
});
$p.IF = (function(x, default$1) {
  return ((x instanceof $j_app$002edata$002e$002dApp$002dDocument$002dData$002dForm.$c_Lapp_data_AppDocumentDataForm$CreditNote) ? x.XC : default$1.h(x));
});
$p.a9 = (function(x) {
  return this.Jz(x);
});
$p.a8 = (function(x, default$1) {
  return this.IF(x, default$1);
});
var $d_Lapp_pages_DocumentsCreatePage$$anon$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_DocumentsCreatePage$$anon$4, "app.pages.DocumentsCreatePage$$anon$4", ({
  HF: 1,
  h: 1,
  f: 1,
  g: 1,
  a: 1
}));
export { $d_Lapp_pages_DocumentsCreatePage$$anon$4 as $d_Lapp_pages_DocumentsCreatePage$$anon$4 };
//# sourceMappingURL=app.pages.-Documents-Create-Page$$anon$4.js.map
